import instance from '../axios'
import { MediaStateItem, MediaStats } from '../context/media-state.types'
import { UpdateAvatarPayload } from './users-api.types'

// One of the user's latest comments, with the title of what it was written on.
export type PublicProfileComment = {
  id: number
  mediaType: 'Movie' | 'Show' | 'Episode' | string
  tmdbMediaId: number
  seasonNumber?: number | null
  content: string
  createdOnUtc: string
  mediaTitle: string
  posterUrl?: string | null
}

export type PinnedMediaItem = {
  mediaType: 'Movie' | 'Show' | string
  tmdbId: number
  title: string
  posterPath?: string | null
  releaseYear?: number | null
}

export type ProfileBadge = {
  key: string
  label: string
  description: string
}

// Owner-only badge case: every badge with progress toward earning it.
export type BadgeProgress = {
  key: string
  label: string
  description: string
  earned: boolean
  current: number
  threshold: number
  hint?: string | null
}

/**
 * GET /users/{idOrUsername}/profile. Public endpoint - works logged out,
 * accepts the numeric id (legacy links) or the username handle.
 * Private profiles come back with isPrivate=true and ONLY the name/username/
 * avatar fields populated; bio, stats, lists, and comments stay empty.
 */
export type PublicProfile = {
  id: number
  name: string
  username?: string | null
  profilePictureUrl?: string | null
  memberSinceUtc: string
  isPrivate: boolean
  bio?: string | null
  stats?: MediaStats | null
  favorites: MediaStateItem[]
  watchlist: MediaStateItem[]
  history: MediaStateItem[]
  recentComments: PublicProfileComment[]
  pinnedShowcase: PinnedMediaItem[]
  badges: ProfileBadge[]
}

const usersApi = {
  getPublicProfile: (idOrUsername: string | number) =>
    instance.get<PublicProfile>(`/users/${idOrUsername}/profile`),

  // Token passed explicitly: this fires on profile mount, which can beat the
  // interceptor's token-getter registration and 401 into the re-login redirect.
  getMyBadges: (token: string) =>
    instance.get<BadgeProgress[]>('/users/me/badges', {
      headers: { Authorization: `Bearer ${token}` },
    }),

  updateAvatar: (payload: UpdateAvatarPayload, token: string) =>
    instance.post('/users/me/avatar', payload, {
      headers: { Authorization: `Bearer ${token} ` }
    })
}

export default usersApi
